module.exports = __webpack_public_path__ + "img/Download.ec885249.svg";